<mat-sidenav-container class="sidenav">
  <mat-sidenav #sidenav [opened]="model.open" (keydown.escape)="close()" mode="over" fixedInViewport="true"
    position="end">
    <div #header class="sidenav-header header-title" fxFlex="none" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <div class="title">{{ "partners.modal.title" | translate }}</div>
      </div>
      <div class="close" (click)="close()" color="warn" fxLayoutAlign="center center">
        <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
      </div>
    </div>
    <mat-card>
      <div appearance="outlined" fxLayout="row" fxLayout.lt-md="column" class="service-container no-padding">
        <form fxFlex="100" [formGroup]="form" #formGroup="ngForm" (submit)="save($event)">
          <div class="sidenav-content" fxLayout="row" fxLayoutAlign="center stretch">
            <div fxFlex="100" fxFlex.gt-sm="100">
              <div class="sidenav-container" fxLayout="column">
                <div class="sidenav-subtitle">
                  {{ "partners.modal.subtitle" | translate }}
                </div>
                <div class="divider">
                  <hr>
                </div>
                <div class="mb-5" fxLayout="column" fxLayoutGap="20px">
                  <mat-form-field fxFlex>
                    <mat-label>{{ "partners.modal.name" | translate }}</mat-label>
                    <input class="sidenav-input" matInput (focusout)="focusOutName()" required type="text"
                      formControlName="name" />
                    <mat-error *ngIf="formGroup.submitted && form.controls.name.errors?.required">
                      {{ "partners.modal.error" | translate }}
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field fxFlex>
                    <mat-label>{{ "partners.modal.key" | translate }}</mat-label>
                    <input class="sidenav-input" matInput required type="text" formControlName="key" />
                    <mat-hint>{{ "partners.modal.hint" | translate }}</mat-hint>
                    <mat-error *ngIf="formGroup.submitted && form.controls.key.errors?.required">
                      {{ "partners.modal.required" | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="divider">
            <hr>
          </div>
          <div class="sidenav-footer" fxLayout="row" fxLayoutAlign="center center">
            <button type="submit" mat-flat-button color="primary">
              {{ "partners.modal.add" | translate }}
            </button>
          </div>
        </form>
      </div>
    </mat-card>
  </mat-sidenav>
</mat-sidenav-container>
